
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import Marquee from "@/components/semantics/Marquee.vue";
import SortHeader from "@/components/base/table/header/SortHeader.vue";
import { Action, Getter, State } from "vuex-class";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { getAreaCN, deepClone, getParentArea } from "@/common/utils";
import { pageViewUnit } from "@/config";
import {
  allCityNum,
  getAddressItemNum,
  nature,
  getDeptNumber,
} from "@/api/common";

@Component({
  name: "policyList",
  components: {
    Marquee,
    SortHeader,
    Pagination,
  },
})
export default class Apply extends Vue {
  @Action("policy/getPublicyList") private getPublicyList: any;
  @Getter("cityName") private cityName: any;
  @Getter("city") private city: any;
  areaOption = this.$root.$data.areaOption;
  loading = false;
  tableData: any = [];
  total = 0;
  pages = 0;
  current = 1;
  size = 15;
  current_option: any = {};
  proviceArr: Array<any> = [];
  cityArr: Array<any> = [];
  townArr: Array<any> = [];
  policyTypeArr: Array<any> = [];
  deptArr: Array<any> = [];
  currentProvince: any = "";
  currentCity: any = "";
  currentTown: any = "";
  currentType: any = "全部";
  currentDept: any = "";
  currentYear: any = "";
  yearTypeArr: any = [
    {
      year: "全部",
      val: "",
    },
    {
      year: new Date().getFullYear(),
      val: new Date().getFullYear(),
    },
    {
      year: new Date().getFullYear() - 1,
      val: new Date().getFullYear() - 1,
    },
    {
      year: new Date().getFullYear() - 2,
      val: new Date().getFullYear() - 2,
    },
  ];
  title: any = "";
  created() {
    this.getAreaOption();
    this.getData(0);
  }
  toDetail({ id: publicyId }: any, column: any, e: any) {
    // this.$router.push({
    //   path: "/pcm/policyDetail",
    //   query: { publicyId },
    // });
	const url = `/#/pcm/policyDetail?publicyId=${publicyId}`;
	window.open(url, "_blank");
  }
  lastName(val: any) {
    if (val) {
      return val.split(",").pop();
    } else {
      return "--";
    }
  }
  async getData(type: any) {
    // 0-default|1-search
    this.loading = true;
    let options: any = {
      pageNumber: this.current,
      pageSize: this.size,
      bigClass: "政策库",
      order: "desc",
      sort: "releaseDate",
      locationAddressCode: this.city.locationAddressCode,
      addressCode: this.currentTown
        ? this.currentTown
        : this.currentCity
        ? this.currentCity
        : this.currentProvince,
      departmentId: this.currentDept,
      nature: this.currentType == "全部" ? "" : this.currentType,
      all: this.currentProvince == "" ? "" : 1,
      title: this.title,
      year: this.currentYear,
    };
    this.getPublicyList(options)
      .then(({ code, result, msg }: any) => {
        if (code === 200) {
          const { total, list, pages } = result;
          const policy_arr: any = [];
          this.tableData = list.map((item: any) => {
            const addressCN = getAreaCN(this.areaOption, item.addressCode);
            item.pageView = (item.pageView || 0) + pageViewUnit;
            item.addressCN = addressCN ? addressCN.label : addressCN;
            return item;
          });
          this.total = total;
          this.pages = pages;
        }
      })
      .finally(() => (this.loading = false));
  }
  clickMarquee(options: any) {
    options.addressCode ? options.addressCode : this.city.id;
    this.current_option = {
      addressCode: options.addressCode,
      departmentId: options.departmentId,
      nature: options.nature,
    };
    this.getData(1);
  }
  search(options: any) {
    this.title = options.title;
    this.getData(0);
  }
  currentChange(params: any) {
    this.current = params;
    this.getData(1);
  }
  // 获取城市信息
  async getAreaOption() {
    const res: any = await allCityNum()
      .then()
      .catch((e: string) => console.error(e));
    const { code, result, msg } = res.data;
    let filterArr = result.filter((item: any) => item.name == "湖北省");
    this.proviceArr = [
      { name: "全部", id: "" },
      { name: "国家", id: "100000" },
      filterArr[0],
    ];

    const res2: any = await nature()
      .then()
      .catch((e: string) => console.error(e));
    this.policyTypeArr = [{ natureName: "全部", id: "" }, ...res2.data.result];
  }
  selectProvince(item: any) {
    this.townArr = [];
    this.currentProvince = item.id;
    this.currentCity = "";
    this.currentTown = "";
    this.currentDept = "";
    if (item.children) {
      this.cityArr = item.children.filter((item: any) => item.name == "黄石市");
    } else {
      this.cityArr = [];
    }
    if (item.id) {
      this.getDeptData(item.id);
    }
    this.getData(0);
  }
  async selectCity(item: any) {
    this.currentCity = item.id;
    this.currentTown = "";
    this.currentDept = "";
    let childArr = await getAddressItemNum(item.id);
    this.townArr = childArr.data.result;
    if (item.id) {
      this.getDeptData(item.id);
    }
    this.getData(0);
  }
  async getDeptData(id: any) {
    const res: any = await getDeptNumber(id);
    this.deptArr = [{ departmentName: "全部", id: "" }, ...res.data.result];
  }
  selectTown(item: any) {
    this.currentTown = item.id;
    this.currentDept = "";
    if (item.id) {
      this.getDeptData(item.id);
    }
    this.getData(0);
  }
  selectDept(item: any) {
    this.currentDept = item.id;
    this.getData(0);
  }
  selectType(item: any) {
    this.currentType = item.natureName;
    this.getData(0);
  }
  selectYear(item: any) {
    this.currentYear = item.val;
    this.getData(0);
  }
}
